module.exports = __webpack_public_path__ + "img/messages_icon.7f3a62dc.svg";